import { render } from "./AggregatedReports.vue?vue&type=template&id=642daa98&scoped=true"
import script from "./AggregatedReports.vue?vue&type=script&lang=js"
export * from "./AggregatedReports.vue?vue&type=script&lang=js"

import "./AggregatedReports.vue?vue&type=style&index=0&id=642daa98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642daa98"]])

export default __exports__